var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { normalizeObject, dataLayerPush, getEhashCookie } from "../shared/utils";
function handleMessageView(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var message_send_template = eventData.message_send_template, message_bible_verse = eventData.message_bible_verse;
    var ehash = getEhashCookie();
    var messageViewData = normalizeObject(__assign(__assign({}, eventData), { event: "msc_message", event_category: "msc_message", event_action: "msc:message_view", event_label: "EMC Message View ".concat(message_send_template, ":").concat(message_bible_verse), non_interaction: 1, ehash: ehash }));
    dataLayerPush(messageViewData);
}
function handleMessageCompose(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var ehash = getEhashCookie();
    var messageComposeData = normalizeObject(__assign(__assign({}, eventData), { event: "msc_message", event_category: "msc_message", event_action: "msc:message_compose_start", event_label: "EMC Message Compose", non_interaction: 0, ehash: ehash }));
    dataLayerPush(messageComposeData);
}
function handleMessageSend(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var message_send_template = eventData.message_send_template, message_bible_verse = eventData.message_bible_verse;
    var ehash = getEhashCookie();
    var messageSendData = normalizeObject(__assign(__assign({}, eventData), { event: "msc_message", event_category: "msc_message", event_action: "msc:message_send_success", event_label: "".concat(message_send_template, ":").concat(message_bible_verse), non_interaction: 0, ret_sponsored_child_message_send_success: 1, retain_interactions: 1, ehash: ehash }));
    dataLayerPush(messageSendData);
}
function handleMessageError(e) {
    var eventData = Object.assign({}, (e === null || e === void 0 ? void 0 : e.detail));
    var messageErrorData = normalizeObject(__assign(__assign({}, eventData), { event: "msc_message", event_category: "msc_message", event_action: "msc:message_error", event_label: "EMC Message Error", non_interaction: 0 }));
    dataLayerPush(messageErrorData);
}
export { handleMessageView, handleMessageCompose, handleMessageSend, handleMessageError, };
